import { render, staticRenderFns } from "./customerOptionLog.vue?vue&type=template&id=19356991&scoped=true&"
import script from "./customerOptionLog.vue?vue&type=script&lang=js&"
export * from "./customerOptionLog.vue?vue&type=script&lang=js&"
import style0 from "./customerOptionLog.vue?vue&type=style&index=0&id=19356991&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19356991",
  null
  
)

export default component.exports